import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
// import { RewardsComponent } from './rewards/rewards.component';
import{RewardsComponent} from '../auth/rewards/rewards.component'

const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent},
  { path: 'rewards', component: RewardsComponent },
  // { path: 'dashboard/:skip-otp', component: DashboardComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-routing.module.ts